import { createContext } from 'react';
var SuperContext = /*#__PURE__*/createContext({});
export default SuperContext;
export var SuperProvider = SuperContext.Provider;
export var SuperConsumer = SuperContext.Consumer;